// extracted by mini-css-extract-plugin
export default {"customLabel":"RadioGroup__customLabel--h3KSG","inputNumberFormat":"RadioGroup__inputNumberFormat--NuMFu"};